import { supabase } from '../config/supabaseConfig.ts';

export const ProyectManagerService = {

  getAll: async () => {
    try {
      const { data, error } = await supabase
        .from('project_manager')
        .select('*')
        .order('id', { ascending: true });
      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error al obtener proyectos:', error);
      throw error;
    }
  },

  createProyect: async (proyect) => {
    try {
      const { data, error } = await supabase
        .from('project_manager')
        .insert([proyect]);
      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error al crear proyecto:', error);
      throw error;
    }
  },

  updateProyect: async (id, proyect) => {
    try {
      const { data, error } = await supabase
        .from('project_manager')
        .update([proyect])
        .eq('id', id);
      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error al actualizar proyecto:', error);
      throw error;
    }
  },

  deleteProyect: async (id) => {
    try {
      const { data, error } = await supabase
        .from('project_manager')
        .delete()
        .eq('id', id);
      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error al eliminar proyecto:', error);
      throw error;
    }
  }

}

export default ProyectManagerService;